import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Button } from '@xing-com/button';
import { mediaConfined, mediaSmallOrTiny } from '@xing-com/layout-tokens';
import { spaceXXL } from '@xing-com/tokens';

import useCustomLink from '../hooks/use-custom-link';

import type { ProductBenefitsProps } from './product-benefits';

const StyledCTAdiv = styled.div`
  display: flex;
  justify-content: center;

  @media ${mediaSmallOrTiny} {
    padding-top: ${spaceXXL};
  }

  @media ${mediaConfined} {
    justify-content: flex-end;
  }
`;

export const GoToProductBtn: React.FC<ProductBenefitsProps> = ({ product }) => {
  const link = useCustomLink(product);

  return (
    <StyledCTAdiv>
      <Button variant={product === 'premium' ? 'premium' : 'proJobs'} to={link}>
        <FormattedMessage
          id={`UPSELL_LOGGED_OUT_PAGE_${product.toUpperCase()}_PRODUCTS_CTA`}
        />
      </Button>
    </StyledCTAdiv>
  );
};
